module.exports = __webpack_public_path__ + "ca517245aa9ba3ccce60b1ed96e57acc.png";